<template>
  <div>
    <d-row lg="12">
      <d-col class="col-lg-12">
        <h5>Invoices</h5>
      </d-col>
    </d-row>
    <d-row lg="12">
      <d-col class="col-lg-12">
        <d-card>
          <d-card-body class="p-0">
            <div class="table-responsive">
              <table class="table mb-0" v-if="invoices.length > 0">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0">
                      <span>Invoice Refrence</span>
                    </th>
                    <th scope="col" class="border-0">
                      <span>Invoice Description</span>
                    </th>
                    <th scope="col" class="border-0">
                      <span>Invoice Number</span>
                    </th>
                    <th scope="col" class="border-0"><span>Email</span></th>
                    <th scope="col" class="border-0">
                      <span>totalAmount</span>
                    </th>
                    <th scope="col" class="border-0">
                      <span>commisionAmount</span>
                    </th>
                    <th scope="col" class="border-0">
                      <span>transferAmount</span>
                    </th>
                    <th scope="col" class="border-0">
                      <span>CommissionPercentage</span>
                    </th>
                    <th scope="col" class="border-0"><span>Actions</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="invoice in invoices" :key="invoice.reference">
                    <td>{{ invoice.reference }}</td>
                    <td>{{ invoice.description }}</td>
                    <td>{{ invoice.invoiceNumber }}</td>
                    <td>{{ invoice.receiverEmail }}</td>
                    <td>{{ priceFormat(invoice.totalAmount) }}</td>
                    <td>{{ priceFormat(invoice.commisionAmount) }}</td>
                    <td>{{ priceFormat(invoice.transferAmount) }}</td>
                    <td>{{ invoice.CommissionPercentage }}</td>
                    <td>{{ invoice.date }}</td>
                    <td @click="previewInvoice(invoice)">
                      <i class="fa fa-regular fa-download"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                <p>There is no invoice for this provider</p>
              </div>
            </div>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import utils from "../../../utils";
export default {
  name: "Invoices",

  apollo: {
    load: function() {
      return {
        fetchPolicy: "no-cache",
        variables: {
          id: this.$route.params.id
        },
        update: function(data) {
          this.invoices = data.provider.invoices;
        },
        query: require("../../../graphql/GetProviderInvoices.gql")
      };
    }
  },

  data: function() {
    invoices: null;

    return {
      invoices: [],
      selectedInvoice: null,
      previewInvoiceModalOpen: false
    };
  },

  methods: {
    isDirty: () => false,

    priceFormat: function(val) {
      return utils.priceFormat(val);
    },

    previewInvoice: function(invoice) {
      window.location.href = invoice.file.url;
    }
  }
};
</script>
